module.exports = __webpack_public_path__ + "img/trial.c62b4a6b.jpg";